import { dbs } from "../firebase/firestore"
import { functions } from '../firebase/firebase'
import { fieryActions, fieryBindings, fieryMapMutations, fieryState, FieryRecordSave, FieryRecordRemove } from 'fiery-vuex'
import { in_obj } from '@/helpers'

const stripeDB: any = dbs.stripe_customers

export default {
	namespaced: true,
	state: {
		current: {},
		payment_methods: {},
		payment_methods_init: false,
		customer: {}
	},
	mutations: {
		SET_CURRENT_STRIPE_CUSTOMER(state, current) {
			state.current = current
		},
		SET_PAYMENT_METHODS(state, payment_methods) {
			state.payment_methods = payment_methods
			state.payment_methods_init = true
		},
		SET_STRIPE_CUSTOMER(state, getCustomer) {
			state.customer = getCustomer()
		}
	},
	getters: {
		hasSubscription(state, getters, rootState, rootGetters) {
			return in_obj(state.current, "subscriptions.data", []).length > 0
		},
		hasPaymentMethods(state, getters, rootState, rootGetters) {
			return in_obj(state.payment_methods, "data", []).length > 0
		},
		paymentMethodsInit(state, getters, rootState, rootGetters) {
			return state.payment_methods_init
		}
	},
	actions: {
		...fieryBindings({
				fetchStripeCustomerLocal({ state, dispatch, commit }, userID, $fiery) {
					userID = userID || state.current.uid
					const doc = stripeDB.doc(userID)
					return $fiery(doc, { key: 'id', record: true }, "SET_STRIPE_CUSTOMER")
				}
			},
			{ commitInitial: false }
		),
		async refreshStripeData({ state, dispatch, commit, rootState }, user_id) {
			return dispatch("fetchStripeCustomer", user_id)
		},
		async fetchStripeCustomer({ state, dispatch, commit, rootState }, user_id) {
			user_id = user_id || rootState.user.current.uid
			dispatch( 'fetchStripeCustomerLocal', user_id )
			const getCustomerData = functions.httpsCallable("getCustomerData")
			let customerData = await getCustomerData(user_id)
			console.log(customerData)
			if (customerData && "data" in customerData) {
				customerData = customerData.data
			}
			await commit("SET_CURRENT_STRIPE_CUSTOMER", customerData)
			await dispatch("fetchPaymentMethods", user_id)
			return true
		},
		async fetchPaymentMethods({ state, dispatch, commit, rootState }, user_id) {
			user_id = user_id || rootState.user.current.uid
			const getPaymentMethods = functions.httpsCallable("getPaymentMethods")
			let paymentMethods = await getPaymentMethods(user_id)
			console.log("!!! FETCHING STRIPE PAYMENT METHODS !!!")
			if (paymentMethods && "data" in paymentMethods) {
				paymentMethods = paymentMethods.data
			}
			await commit("SET_PAYMENT_METHODS", paymentMethods)
			return true
		}
	}
}